import { Instance } from 'mobx-state-tree'
import { GetBillingDetailsModelBase } from './GetBillingDetailsModel.base'

/* The TypeScript type of an instance of GetBillingDetailsModel */
export interface GetBillingDetailsModelType extends Instance<typeof GetBillingDetailsModel.Type> {}

/* A graphql query fragment builders for GetBillingDetailsModel */
export {
  selectFromGetBillingDetails,
  getBillingDetailsModelPrimitives,
  GetBillingDetailsModelSelector
} from './GetBillingDetailsModel.base'

/**
 * GetBillingDetailsModel
 */
export const GetBillingDetailsModel = GetBillingDetailsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
